/**
 * @file wordpress.interceptor.ts
 */
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@root/environments/environment';
import { AppConstants } from '@root/app/app.constants';

@Injectable()
export class WordpressInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (request.url.startsWith(`${environment.hostURL}/wordpress/index.php`)) {
      request = request.clone({
        setHeaders: {
          'ProviderType': AppConstants.GUEST_PROVIDER_TYPE,
           Authorization: ''
        }
      });
    }
    return next.handle(request);
  }
}
